import {TErrorManagers, IExportTemplateMutable} from "../../index";
import {IRouteDefinitionParams, IRuleset} from "../../../../index";
import {Mutable} from "../../mutable";

type TMailFlowAttribute =
    'disableOwa' |
    'DomainController' |
    'ExtraSMTP' |
    'mailPath' |
    'mailStore' |
    'mailVersion' |
    'primarySMTPDomain' |
    'proxyAddresses' |
    'TargetAddress'
    ;

interface IParams extends IRouteDefinitionParams {
    exporttemplate: IExportTemplateMutable
    mutable: Mutable
    rulesets: IRuleset[]
}
